import React from 'react';

import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';

import { normalizeTransferItem } from '../../../../shared/utils/files/common';

import { showRenameSelectedFilesModal } from '../../../../shared/utils/files/upload-helper';

const label = 'copyTo';

function handler(apiOptions, actions) {
  const { showDialog, hideDialog, navigateToDir, setParentsForResource, getSelectedResources, rootContainer, controlConfiguration } = actions;

  const getMessage = getMess.bind(null, apiOptions.locale);
  const selectedResources = getSelectedResources();

  const rawDialogElement = {
    elementType: 'MoveToDialog',
    elementProps: {
      onHide: hideDialog,
      rootContainer: rootContainer,
      controlConfiguration: controlConfiguration,
      onSubmit: async (selectedDestinationFolder) => {
        api
          .getFilesInDestinationFolder(
            apiOptions,
            selectedResources.map((x) => x.name),
            selectedDestinationFolder,
          )
          .then((existingFiles) => {
            if (existingFiles.length) {
              const existingfileNames = _.uniqBy(existingFiles, 'name').map((x) => x.name);

              showRenameSelectedFilesModal(
                existingfileNames,
                rootContainer,
                () => {
                  hideDialog();
                  api
                    .copyResources(
                      apiOptions,
                      selectedResources.map((x) => normalizeTransferItem(x)),
                      selectedDestinationFolder,
                    )
                    .then((res) => {
                      navigateToDir(selectedDestinationFolder, null);
                      setParentsForResource(selectedDestinationFolder);
                    });
                },
                () => {
                  hideDialog();
                  const choosenItems = selectedResources.filter((f) => !existingfileNames.includes(f.name)) || [];
                  const transferItems = choosenItems.length ? choosenItems.map((x) => normalizeTransferItem(x)) : null;

                  if (transferItems && transferItems.length) {
                    api.copyResources(apiOptions, transferItems, selectedDestinationFolder).then((res) => {
                      navigateToDir(selectedDestinationFolder, null);
                      setParentsForResource(selectedDestinationFolder);
                    });
                  }
                },
              );
            } else {
              hideDialog();
              api
                .copyResources(
                  apiOptions,
                  selectedResources.map((x) => normalizeTransferItem(x)),
                  selectedDestinationFolder,
                )
                .then((res) => {
                  navigateToDir(selectedDestinationFolder, null);
                  setParentsForResource(selectedDestinationFolder);
                });
            }
          })
          .catch((error) => {
            console.error(error);
            hideDialog();
          });
        return null;
      },
      onValidate: async (selection, resourceLocation) => {
        // check whether current folder is the same as in files which user wants to move
        if (resourceLocation && selectedResources && resourceLocation[resourceLocation.length - 1].id === selectedResources[0].parentId) {
          return false;
        }

        if (selection && selection.length) {
          if (selectedResources && selectedResources[0].parentId === selection[0]) {
            return false;
          }
        }

        return true;
      },
      headerText: getMessage('copyTo'),
      submitButtonTextWithSelectedFolder: getMessage('copyTo'),
      submitButtonTextWithoutSelectedFolder: getMessage('copyHere'),
      cancelButtonText: getMessage('cancel'),
      movableFiles: selectedResources || [],
    },
  };
  showDialog(rawDialogElement);
}

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;
  return {
    id: label,
    icon: { icon: icons.copy },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const selectedResources = getSelectedResources();

      if (!selectedResources.length) {
        return false;
      }

      return selectedResources.every((resource) => resource.capabilities.canDelete);
    },
    availableInContexts: ['row', 'toolbar'],
    handler: () => handler(apiOptions, actions),
  };
};
